import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Fields, UserData } from 'utils';

type ReturnType = Promise<AxiosResponse<UserData>>;

const updateUserProfile = (
    userUuid: string | null,
    first_name: string | null,
    last_name: string | null,
    email: string | null,
    user_name: string | null,
    phone: string | null,
    profile_photo: string | null,
    primary_sport?: string | null,
    fields?: Fields,
    preferred_speed_unit?: string | null,
): ReturnType => {
    let payload = {
        first_name,
        last_name,
        email,
        user_name,
        phone,
        profile_photo,
        primary_sport,
        fields,
        preferred_speed_unit,
    };

    return Request.put(
        `/users/${userUuid}`,
        Object.fromEntries(
            Object.entries(payload).filter(([key, value]) => {
                if (key === 'primary_sport' || key === 'preferred_speed_unit')
                    return value !== undefined;
                return value != null;
            }),
        ),
    );
};

export default updateUserProfile;
